export default {"src":"/_next/static/media/minimize.5f369166.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};